export const NAV_DRAWER_MESSAGES = {
  settingsMenu: {
    'settings:notifications.title': 'Notifications',
    'common:vehicles': 'Vehicles',
    'common:account': 'Account',
    'common:safetyAndSecurity': 'Safety & Security',
  },
  accountMenu: {
    'common:account': 'Account',
    'account:organization.nav.title': 'Organization',
    'organization:fleetPrograms': 'Fleet programs',
    'account:profile': 'Personal details',
    'account:preferences': 'Preferences',
    'account:languageAndRegion': 'Language & Region',
    'account:settings': 'Settings',
    'settings:notifications.title': 'Notifications',
    'common:vehicles': 'Vehicles',
    'common:safetyAndSecurity': 'Safety & Security',
    'account:support.nav.faqs': 'FAQs',
    'account:support.nav.contact': 'Contact',
    'common:header.support': 'Support',
  },
  advisorMenu: {
    'common:vehicle': 'Vehicle',
    'common:user': 'User',
    'common:vehicle_plural': 'Vehicles',
    'common:user_plural': 'Users',
    'common:organization': 'Organization',
    'common:organization_plural': 'Organizations',
  },
  fleetMenu: {
    'common:home': 'Home',
    'common:vehicles': 'Vehicles',
    'asset:vehicleMap': 'Map',
    'order:tableTitle': 'Orders',
    'common:shop': 'Shop',
    'entitlements:planList.title': 'OnStar plans',
  },
  supportMenu: {
    'account:support.nav.title': 'Support',
    'account:support.nav.contact': 'Contact',
    'account:support.nav.faqs': 'FAQs',
  },
  legacyMenu: {
    'common:organization': 'Organization',
    'common:hub': 'Hub',
    'common:fleet': 'Fleet',
    'common:organization_plural': 'Organizations',
    'common:asset_plural': 'Vehicles',
    'common:user_plural': 'Users',
    'common:device_plural': 'Devices',
    'common:footer.support': 'Support',
    'user:privacyStatement': 'Privacy Statement',
    'common:navDrawer.gmFleet': 'GM Fleet',
    'insight:title': 'Insights',
    'purchasePrograms:purchasePrograms': 'Fleet programs',
  },
};
